export class SnackBarClass{
    constructor(
        public testo:string,        
        public bottoneOk:boolean,
        public design:number=0 //0-normal 1-Success 2-Danger
    ){}
}